module.exports = __webpack_public_path__ + "media/product/ctg-4-1466d0fb.png";